{
  "version": 1,
  "asset_id": "79956c8b-4afe-4ba8-be05-e9551bd71d7a",
  "project_id": "a3729fa2-e85b-4f5b-84b2-0934e880c580",
  "url": "/__l5e/assets-v1/79956c8b-4afe-4ba8-be05-e9551bd71d7a/egg-verdant.webp",
  "r2_key": "a/v1/a3729fa2-e85b-4f5b-84b2-0934e880c580/79956c8b-4afe-4ba8-be05-e9551bd71d7a/egg-verdant.webp",
  "original_filename": "egg-verdant.webp",
  "size": 6162,
  "content_type": "image/webp",
  "created_at": "2026-08-06T21:54:23Z"
}
